export default "__VITE_ASSET__kEEgVRaK__"